import { render, staticRenderFns } from "./Detail-Promotion.vue?vue&type=template&id=09c460a0"
import script from "./Detail-Promotion.vue?vue&type=script&lang=js"
export * from "./Detail-Promotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports